import * as styles from './SelectDropdown.module.css'

function SelectDropdown({
  children,
  className = styles.SelectDropdown,
  ref,
  ...elementProps
}) {
  return (
    <div {...elementProps} className={className} ref={ref}>
      {children}
    </div>
  )
}

export default SelectDropdown
